import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <>
    <div className="f-container">
    <div className="f-left">
        <div className="logo" >
        <img src="./logo.jpg" alt="im" width={140} />
        <div className='bot'>Our vision is to provide you best properties</div>
        </div>
        
    </div>

    <div className="f-right">
    <span className='prim'>Noida,New Delhi 
        </span> 
        <div className=" f-menu">
            <span> Property</span>
            <span> Services</span>
            <span>About Us</span>
          </div>       

    </div>

    </div>
    
     <footer className="footer">
      <p>© {new Date().getFullYear()} Real Estate Co. | All Rights Reserved</p>
    </footer>

      
    </>
  )
};

export default Footer
